module.exports = __webpack_public_path__ + "static/media/mode-39.a210c598.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-39.svg
// module id = 1012
// module chunks = 2